
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/szolgaltatasok/online-tanacsadas",
      function () {
        return require("private-next-pages/szolgaltatasok/online-tanacsadas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/szolgaltatasok/online-tanacsadas"])
      });
    }
  